import { render, staticRenderFns } from "./loan-number.vue?vue&type=template&id=1bafdca4&scoped=true&lang=html&"
import script from "./loan-number.vue?vue&type=script&lang=js&"
export * from "./loan-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bafdca4",
  null
  
)

export default component.exports